<template>
    <div class="grid grid-cols-6">
        <div class="col-span-4 sm:col-span-4">
            <input class="form-input rounded-md border border-solid border-black w-full py-2 px-3"
                   v-mask="['###.###.###-##','##.###.###/####-##']"
                   @focusout="getDoc(loadOnFocusOut)"
                   :value="value" @input="$emit('input', $event.target.value)" ref="input">
        </div>
        <div class="col-span-2 sm:col-span-2 w-full">
            <button
                class="ml-2 py-1.5 px-0"
                @click="getDoc(true)">
                <i class="fas" v-bind:class="{ 'fa-spinner animate-spin': loading, 'fa-search': !loading }"/>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        value: String,
        target: Function,
        auto: {
            type: Boolean,
            default: false
        },
        loadOnFocusOut: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            loading: false,
            document: null
        };
    },
    updated() {
        this.$nextTick(function () {
            if (this.auto && this.value) {
                this.getDoc()
            }
        })
    },
    methods: {
        loading_(value) {
            this.loading = value
        },
        focus() {
            this.$refs.input.focus()
        },
        getDoc(exec) {
            if (exec) {
                this.search(this.loading_, this.value, this.target, this);
            }
        },
        search: (loading, doc, callback, vm) => {

            try {
                if (doc !== '' && doc.length !== 14 && doc.length !== 18) {
                    return;
                }
                loading(true)
                fetch(
                    `/json/document/${escape(doc.replace(/[^0-9]/g, ''))}`
                ).then(res => {
                    res.json().then(json => {
                        let name = null;
                        if (json.hasOwnProperty('basic_data')) {
                            name = json.basic_data.Name || json.basic_data.OfficialName;
                        }else if (json.hasOwnProperty('data')){
                            name = json.data.name;
                        }
                        if (!name) {
                            vm.$toast.open({
                                message: json.message || 'CPF ou CNPJ inválido. Verifique os dados e tente novamente',
                                type: 'error',
                                duration: 5000,
                                position: 'top-right'
                            });
                            return;
                        }
                        callback(json);
                    });
                }).finally(() => {
                    loading(false);
                })
            } catch (e) {
                focus();
            }


        }
    }
}
</script>

